
namespace Matrix.Exceptions {

    @Serenity.Decorators.registerClass()
    export class ExceptionPolicyIgnoreDialog extends SiteEntityDialog<ExceptionPolicyIgnoreRow, any> {
        protected getFormKey() { return ExceptionPolicyIgnoreForm.formKey; }
        protected getIdProperty() { return ExceptionPolicyIgnoreRow.idProperty; }
        protected getLocalTextPrefix() { return ExceptionPolicyIgnoreRow.localTextPrefix; }
        protected getNameProperty() { return ExceptionPolicyIgnoreRow.nameProperty; }
        protected getService() { return ExceptionPolicyIgnoreService.baseUrl; }
        protected getDeletePermission() { return ExceptionPolicyIgnoreRow.deletePermission; }
        protected getInsertPermission() { return ExceptionPolicyIgnoreRow.insertPermission; }
        protected getUpdatePermission() { return ExceptionPolicyIgnoreRow.updatePermission; }

        protected form = new ExceptionPolicyIgnoreForm(this.idPrefix);

    }
}